"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRandomizationChains = void 0;
var MIN_CHAIN_LENGTH_DEFAULT = 3;
var checkRandomizationChains = function (rotations, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var minChainLength = options.minChainLength || MIN_CHAIN_LENGTH_DEFAULT;
    var chains = [];
    var i = 0;
    while (i < rotations.length) {
        rotations[i];
        var j = i + 1;
        while (j < rotations.length) {
            if (rotations[i].mediafileId === rotations[j].mediafileId) {
                var chainLength = 0;
                var start = rotations[i].id;
                var secondStart = rotations[j].id;
                do {
                    chainLength += 1;
                    i += 1;
                    j += 1;
                } while (rotations[i] &&
                    rotations[j] &&
                    ((_a = rotations[i].mediafile) === null || _a === void 0 ? void 0 : _a.id) === ((_b = rotations[j].mediafile) === null || _b === void 0 ? void 0 : _b.id));
                chains.push({
                    start: start,
                    secondStart: secondStart,
                    length: chainLength,
                });
            }
            j += 1;
        }
        i += 1;
    }
    return chains.filter(function (chain) { return chain.length >= minChainLength; });
};
exports.checkRandomizationChains = checkRandomizationChains;
//# sourceMappingURL=checkRandomizationChains.js.map